import React from "react";

const DealSvg = ({ fill }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8762 6.02411C15.57 5.8986 16.2786 6.14764 16.7413 6.67959L17.9145 8.02835C18.3772 8.5603 18.5256 9.29657 18.3052 9.96625L17.343 12.8893C17.2304 13.2313 17.0275 13.5366 16.7558 13.773L8.89797 20.6079C8.06456 21.3328 6.80129 21.2448 6.07637 20.4114L2.83722 16.6875C2.1123 15.8541 2.20026 14.5908 3.03367 13.8659L10.8915 7.03097C11.1632 6.79464 11.4937 6.63605 11.8481 6.57194L14.8762 6.02411Z"
        stroke={fill === "none" && "#718596"}
      />
      <circle
        cx="13.9569"
        cy="10.2861"
        r="2.03081"
        transform="rotate(-41.0173 13.9569 10.2861)"
        stroke={fill === "none" && "#718596"}
      />
      <path
        d="M18.2616 5.95211C19.1072 5.39177 20.5731 3.94149 19.6724 2.62305"
        stroke={fill === "none" && "#718596"}
        stroke-linecap={fill === "none" && "round"}
      />
    </svg>
  );
};

export default DealSvg;
